module.exports = __webpack_public_path__ + "3da2f2736652f29e97431d28712c9d8c.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/turn_off.png
// module id = 2869
// module chunks = 0